export default {
  en: {
    yesAndUpdatedWithin: 'Yes & updated within {n} month | Updated within {n} months',
    yes: 'Yes',
    no: 'No',
    unanswered: 'Unanswered',
    notApplicable: 'Not applicable',
    invalid: 'Invalid',
    notRequired: 'Not required',
    requireYes: 'Require yes',
    requireColMonths: 'Yes - within {n} month | Yes - within {n} months',
    requireColYears: 'Yes - within {n} year | Yes - within {n} years',
    requireHeading: 'Continuity period',
    outOfScope: 'Out of scope',
    answer: 'Answer',
    answered: 'Answered',
    youAnswered: 'You answered',
    editAnswer: 'Edit answer',
    lastModified: 'Last modified {0}',
    dateFormat: 'yyyy/MM/dd',
    pastDateRequired: 'A date is required to save this answer.',
    lastUpdated: 'Last updated',
    policyPlaceholder: 'Select your required validity period',
    months: 'Updated within {n} month | Updated within {n} months',
    years: 'Updated within {n} year | Updated within {n} years',
    expiresOnDate: 'Yes (updated on {0})',
    errors: {
      emptySelect: 'Requires one field to be selected.',
    },
  },
};
